require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./centres-east-malvern-early-learning-centre.json") })
        }
      }, "path---centres-east-malvern-early-learning-centre");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---centres-east-malvern-early-learning-centre!./.cache/json/centres-east-malvern-early-learning-centre.json
// module id = 1227
// module chunks = 231608221292675